import { render, staticRenderFns } from "./pca.vue?vue&type=template&id=a0247070&scoped=true&"
import script from "./pca.vue?vue&type=script&lang=js&"
export * from "./pca.vue?vue&type=script&lang=js&"
import style0 from "./pca.vue?vue&type=style&index=0&id=a0247070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0247070",
  null
  
)

export default component.exports